import { cn } from '@/lib/utils';
import styles from './CountBadge.module.css';

export interface CountBadgeProps {
  count: number;
  max?: number;
  className?: string;
}

/** Small circular numeric badge, e.g. a pending-count indicator on a tab. Renders nothing when count <= 0. */
export const CountBadge = ({ count, max = 99, className }: CountBadgeProps) => {
  if (count <= 0) return null;

  return (
    <span className={cn(styles.badge, className)}>
      {count > max ? `${max}+` : count}
    </span>
  );
};
